var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadmapStripShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 4,
    viewBox: "0 0 422 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1628_3322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4 0L5.5 4H0L1.9 0H7.4ZM10.9 0L9 4H14.5L16.4 0H10.9ZM19.9 0L18 4H23.5L25.4 0H19.9ZM28.9 0L27 4H32.5L34.4 0H28.9ZM37.9 0L36 4H41.5L43.4 0H37.9ZM46.9 0L45 4H50.5L52.4 0H46.9ZM55.9 0L54 4H59.5L61.4 0H55.9ZM64.9 0L63 4H68.5L70.4 0H64.9ZM73.9 0L72 4H77.5L79.4 0H73.9ZM82.9 0L81 4H86.5L88.4 0H82.9ZM91.9 0L90 4H95.5L97.4 0H91.9ZM100.9 0L99 4H104.5L106.4 0H100.9ZM109.9 0L108 4H113.5L115.4 0H109.9ZM118.9 0L117 4H122.5L124.4 0H118.9ZM127.9 0L126 4H131.5L133.4 0H127.9ZM136.9 0L135 4H140.5L142.4 0H136.9ZM145.9 0L144 4H149.5L151.4 0H145.9ZM154.9 0L153 4H158.5L160.4 0H154.9ZM163.9 0L162 4H167.5L169.4 0H163.9ZM172.9 0L171 4H176.5L178.4 0H172.9ZM181.9 0L180 4H185.5L187.4 0H181.9ZM190.9 0L189 4H194.5L196.4 0H190.9ZM199.9 0L198 4H203.5L205.4 0H199.9ZM208.9 0L207 4H212.5L214.4 0H208.9ZM217.9 0L216 4H221.5L223.4 0H217.9ZM226.9 0L225 4H230.5L232.4 0H226.9ZM235.9 0L234 4H239.5L241.4 0H235.9ZM244.9 0L243 4H248.5L250.4 0H244.9ZM253.9 0L252 4H257.5L259.4 0H253.9ZM262.9 0L261 4H266.5L268.4 0H262.9ZM271.9 0L270 4H275.5L277.4 0H271.9ZM280.9 0L279 4H284.5L286.4 0H280.9ZM289.9 0L288 4H293.5L295.4 0H289.9ZM298.9 0L297 4H302.5L304.4 0H298.9ZM307.9 0L306 4H311.5L313.4 0H307.9ZM316.9 0L315 4H320.5L322.4 0H316.9ZM325.9 0L324 4H329.5L331.4 0H325.9ZM334.9 0L333 4H338.5L340.4 0H334.9ZM343.9 0L342 4H347.5L349.4 0H343.9ZM352.9 0L351 4H356.5L358.4 0H352.9ZM361.9 0L360 4H365.5L367.4 0H361.9ZM370.9 0L369 4H374.5L376.4 0H370.9ZM379.9 0L378 4H383.5L385.4 0H379.9ZM388.9 0L387 4H392.5L394.4 0H388.9ZM397.9 0L396 4H401.5L403.4 0H397.9ZM406.9 0L405 4H410.5L412.4 0H406.9ZM415.9 0L414 4H419.5L421.4 0H415.9Z",
    fill: "url(#paint0_linear_1628_3322)",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1628_3322",
    x1: 0,
    y1: 2,
    x2: 421.382,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1628_3322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 421.4,
    height: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapStripShape);
export default __webpack_public_path__ + "static/media/roadmap_strip_shape.949ae981cf807bf66098a29f79766e2b.svg";
export { ForwardRef as ReactComponent };